var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "rgb(255, 255, 255)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    dur: "0.7575757575757576s",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    fill: "#e6007e",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    dur: "1.0101010101010102s",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 50 50)",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    fill: "#ffcc01",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    dur: "1.5151515151515151s",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 50 50)",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    fill: "#10c96d",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    dur: "3.0303030303030303s",
    keyTimes: "0;1",
    values: "0 50 50;360 50 50",
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(270 50 50)",
    d: "M50 50L50 0A50 50 0 0 1 100 50Z",
    fill: "#00b5e2",
    fillOpacity: 0.8
  }))))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedges);
export default __webpack_public_path__ + "static/media/Wedges.b84bba5f6030248e692318f1a67518f1.svg";
export { ForwardRef as ReactComponent };